import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';
import { useAuthStore } from '@/stores/auth.store';

export const VerifyOtpInputSchema = z.object({
  code: z.string().length(6, 'Koden är ogiltig'),
  authenticationId: z.string().uuid(),
});

export type VerifyOtpInput = z.infer<typeof VerifyOtpInputSchema>;

export type VerifyOtpResult = {
  token: string;
};

export const verifyOtp = async ({ data }: { data: VerifyOtpInput }): Promise<VerifyOtpResult> => {
  return (await api.post(`/auth/login/otp/verify`, data)).data;
};

type UseVerifyOtpOptions = {
  mutationConfig?: MutationConfig<typeof verifyOtp>;
};

export const useVerifyOtp = ({ mutationConfig }: UseVerifyOtpOptions = {}) => {
  const queryClient = useQueryClient();
  const login = useAuthStore((state) => state.login);

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      //queryClient.refetchQueries({});
      login(data.token);
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: verifyOtp,
  });
};
